import { formDataRequest, getRequest, postRequest } from '../libs/AxiosService.util';

export async function serviceGetPrimaryUserUpdateList(params) {
    return await getRequest('primary/user/updates/list', params);
}
export async function serviceGetVendorDetail(params) {
    return await postRequest('vendor/detail', params);
}
export async function serviceVendorUpdate(params) {
    return await formDataRequest('vendor/update', params);
}
export async function serviceVendorCreate(params) {
    return await formDataRequest('vendor/create', params);
}
export async function serviceVendorIsExist(params) {
    return await postRequest('vendor/check', params);
}
